import React, { createContext, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { authAction, notificationAction, configAction } from '../redux/actions'
import { useBoolean, useToast } from '@chakra-ui/react'
import { configureAbly, useChannel } from "@ably-labs/react-hooks"
import { v4 as uuidv4 } from 'uuid';


const accessToken = process.env.REACT_APP_ACCESS_TOKEN

const initialState = {
    user: null,   
    token: localStorage.getItem(accessToken)
};

const AuthContext = createContext({
    ...initialState,
    init: () => Promise.resolve(),
    login: () => Promise.resolve(),     
    logout: () => Promise.resolve(),
});

configureAbly({ key: process.env.REACT_APP_ABLY_KEY, clientId: uuidv4() });

export const AuthProvider = (props) => {
    const toast = useToast()
    const auth = useSelector(state => state.auth);    
    const { config } = useSelector(state => state?.config)
    const [state, setState] = useState({...initialState})
    const [ mount, setMount] = useBoolean()
    const [ loading, setLoading ] = useBoolean()
    const dispatch = useDispatch()
    const audio = new Audio('/assets/bell.mp3');
    

    const playSound = () => {                
        audio.play();        
    };

    
    // useChannel("public:admin", (message) => {
    //     console.log(message)
    //     // alert(process.env.REACT_APP_API_URL+"download/"+message?.data?.user, "File Download");
    // });

    const is_admin = () => {
        return auth?.user?.type === 'ADMIN'
    }

    useChannel("public:export", (message) => {
        // console.log("Message Recieved")   
        if(message?.data?.payload?.channel === 'admin-export' ||  message?.data?.payload?.channel === auth?.user?.id+"-export" ){
            console.log(message?.data?.payload)
            dispatch(notificationAction.add(message?.data?.payload));        
            playSound()
            toast({
                title:  message?.data?.payload?.payload?.title,
                description:  message?.data?.payload?.payload?.message,
                status: "success",
                position: "top-right",
                isClosable: true,
                duration: 3000
            })
        }
        // alert(process.env.REACT_APP_API_URL+"download/"+message?.data?.user, "File Download");
    });




    const login = (form_data) => {
        return new Promise((resolve, reject) => {
            dispatch(authAction.clear())
            .then(() => {
                return dispatch(authAction.login(form_data))
            })            
            .then((response) => {
                resolve(response) 
            })
            .catch((error) => reject(error) )
        })

    }

    const logout = () => {
        return new Promise((resolve, reject) => {
            dispatch(authAction.logout())        
                .then(() => {                        
                    resolve()
                })
                .catch((e) => {
                    reject()
                })
        })

    }

    

    useEffect(() => {
        const init = async () => {   
            setLoading.on()                      
            try{
                await dispatch(authAction.auth_check())
                await dispatch(configAction.get())
                setMount.on()
                setLoading.off()
            }
            catch(err){                                
                console.log("Auth Error", err)
                setMount.on()
                setLoading.off()
            }
        }
        if(!mount && !loading){
            init()                  
        }
        

    }, [mount, setMount, state, loading, setState, setLoading, dispatch])
    
    
    
    return (
        <AuthContext.Provider
            value={{
                ...state,
                ...auth,
                config,
                loading,
                setLoading,                
                login,
                logout,
                is_admin,
            }}>
            {props.children}
            
        </AuthContext.Provider>
    );
}

export  {AuthContext}